import { MeasurementUnit } from './types';
const MM_TO_PT = 2.834646;
const CM_TO_MM = 10;
const CM_TO_PT = 28.34646;
const IN_TO_CM = 2.54;
const IN_TO_MM = 25.4;
const IN_TO_M = 0.0254;
const IN_TO_PT = 72;
const FT_TO_IN = 12;
const FT_TO_CM = 30.48;
const FT_TO_M = 0.3048;
const FT_TO_MM = 304.8;
const FT_TO_PT = 864;
const YD_TO_FT = 3;
const YD_TO_IN = 36;
const YD_TO_CM = 91.44;
const YD_TO_MM = 914.4;
const YD_TO_PT = 2592;
const YD_TO_M = 0.9144;
const M_TO_CM = 100;
const M_TO_MM = 1000;
const M_TO_PT = 2834.646;
// Source is in millimeters
export function mm2in(mm) {
    return mm / IN_TO_MM;
}
export function mm2ft(mm) {
    return mm / FT_TO_MM;
}
export function mm2yd(mm) {
    return mm / YD_TO_MM;
}
export function mm2cm(mm) {
    return mm / CM_TO_MM;
}
export function mm2m(mm) {
    return mm / M_TO_MM;
}
export function mm2pt(mm) {
    return mm * MM_TO_PT;
}
// Source is in centimeters
export function cm2in(cm) {
    return cm / IN_TO_CM;
}
export function cm2ft(cm) {
    return cm / FT_TO_CM;
}
export function cm2yd(cm) {
    return cm / YD_TO_CM;
}
export function cm2mm(cm) {
    return cm * CM_TO_MM;
}
export function cm2m(cm) {
    return cm / M_TO_CM;
}
export function cm2pt(cm) {
    return cm * CM_TO_PT;
}
// Source is in meters
export function m2in(m) {
    return m / IN_TO_M;
}
export function m2ft(m) {
    return m / FT_TO_M;
}
export function m2yd(m) {
    return m / YD_TO_M;
}
export function m2mm(m) {
    return m * M_TO_MM;
}
export function m2cm(m) {
    return m * M_TO_CM;
}
export function m2pt(m) {
    return m * M_TO_PT;
}
// Source is in inches
export function in2ft(inch) {
    return inch / FT_TO_IN;
}
export function in2yd(inch) {
    return inch / YD_TO_IN;
}
export function in2mm(inch) {
    return inch * IN_TO_MM;
}
export function in2cm(inch) {
    return inch * IN_TO_CM;
}
export function in2m(inch) {
    return inch * IN_TO_M;
}
export function in2pt(inch) {
    return inch * IN_TO_PT;
}
// Source is in feet
export function ft2in(ft) {
    return ft * FT_TO_IN;
}
export function ft2yd(ft) {
    return ft / YD_TO_FT;
}
export function ft2mm(ft) {
    return ft * FT_TO_MM;
}
export function ft2cm(ft) {
    return ft * FT_TO_CM;
}
export function ft2m(ft) {
    return ft * FT_TO_M;
}
export function ft2pt(ft) {
    return ft * FT_TO_PT;
}
// Source is in yards
export function yd2in(yd) {
    return yd * YD_TO_IN;
}
export function yd2ft(yd) {
    return yd * YD_TO_FT;
}
export function yd2mm(yd) {
    return yd * YD_TO_MM;
}
export function yd2cm(yd) {
    return yd * YD_TO_CM;
}
export function yd2m(yd) {
    return yd * YD_TO_M;
}
export function yd2pt(yd) {
    return yd * YD_TO_PT;
}
// Source is in points
export function pt2in(pt) {
    return pt / IN_TO_PT;
}
export function pt2ft(pt) {
    return pt / FT_TO_PT;
}
export function pt2yd(pt) {
    return pt / YD_TO_PT;
}
export function pt2mm(pt) {
    return pt / MM_TO_PT;
}
export function pt2cm(pt) {
    return pt / CM_TO_PT;
}
export function pt2m(pt) {
    return pt / M_TO_PT;
}
/** ********************* End of micro-utility functions ****************************** */
// Converters utilizing micro-utility functions
export function convertToMm(size, fromUnits) {
    switch (fromUnits) {
        case MeasurementUnit.IN:
            return in2mm(size);
        case MeasurementUnit.FT:
            return ft2mm(size);
        case MeasurementUnit.YD:
            return yd2mm(size);
        case MeasurementUnit.CM:
            return cm2mm(size);
        case MeasurementUnit.M:
            return m2mm(size);
        case MeasurementUnit.PT:
            return pt2mm(size);
        case MeasurementUnit.MM:
        default:
            return size;
    }
}
export function convertToCm(size, fromUnits) {
    switch (fromUnits) {
        case MeasurementUnit.IN:
            return in2cm(size);
        case MeasurementUnit.FT:
            return ft2cm(size);
        case MeasurementUnit.YD:
            return yd2cm(size);
        case MeasurementUnit.MM:
            return mm2cm(size);
        case MeasurementUnit.M:
            return m2cm(size);
        case MeasurementUnit.PT:
            return pt2cm(size);
        case MeasurementUnit.CM:
        default:
            return size;
    }
}
export function convertToM(size, fromUnits) {
    switch (fromUnits) {
        case MeasurementUnit.IN:
            return in2m(size);
        case MeasurementUnit.FT:
            return ft2m(size);
        case MeasurementUnit.YD:
            return yd2m(size);
        case MeasurementUnit.MM:
            return mm2m(size);
        case MeasurementUnit.CM:
            return cm2m(size);
        case MeasurementUnit.PT:
            return pt2m(size);
        case MeasurementUnit.M:
        default:
            return size;
    }
}
export function convertToIn(size, fromUnits) {
    switch (fromUnits) {
        case MeasurementUnit.FT:
            return ft2in(size);
        case MeasurementUnit.YD:
            return yd2in(size);
        case MeasurementUnit.MM:
            return mm2in(size);
        case MeasurementUnit.CM:
            return cm2in(size);
        case MeasurementUnit.M:
            return m2in(size);
        case MeasurementUnit.PT:
            return pt2in(size);
        case MeasurementUnit.IN:
        default:
            return size;
    }
}
export function convertToFt(size, fromUnits) {
    switch (fromUnits) {
        case MeasurementUnit.IN:
            return in2ft(size);
        case MeasurementUnit.YD:
            return yd2ft(size);
        case MeasurementUnit.MM:
            return mm2ft(size);
        case MeasurementUnit.CM:
            return cm2ft(size);
        case MeasurementUnit.M:
            return m2ft(size);
        case MeasurementUnit.PT:
            return pt2ft(size);
        case MeasurementUnit.FT:
        default:
            return size;
    }
}
export function convertToYd(size, fromUnits) {
    switch (fromUnits) {
        case MeasurementUnit.IN:
            return in2yd(size);
        case MeasurementUnit.FT:
            return ft2yd(size);
        case MeasurementUnit.MM:
            return mm2yd(size);
        case MeasurementUnit.CM:
            return cm2yd(size);
        case MeasurementUnit.M:
            return m2yd(size);
        case MeasurementUnit.PT:
            return pt2yd(size);
        case MeasurementUnit.YD:
        default:
            return size;
    }
}
export function convertToPt(size, fromUnits) {
    switch (fromUnits) {
        case MeasurementUnit.IN:
            return in2pt(size);
        case MeasurementUnit.FT:
            return ft2pt(size);
        case MeasurementUnit.MM:
            return mm2pt(size);
        case MeasurementUnit.CM:
            return cm2pt(size);
        case MeasurementUnit.M:
            return m2pt(size);
        case MeasurementUnit.YD:
            return yd2pt(size);
        case MeasurementUnit.PT:
        default:
            return size;
    }
}
// Overall encompassing converter
export function convert(size, fromUnits, toUnits) {
    const nullFixedSize = size !== null && size !== void 0 ? size : 0; // Necessary for null inputs
    switch (toUnits) {
        case MeasurementUnit.IN:
            return convertToIn(nullFixedSize, fromUnits);
        case MeasurementUnit.FT:
            return convertToFt(nullFixedSize, fromUnits);
        case MeasurementUnit.YD:
            return convertToYd(nullFixedSize, fromUnits);
        case MeasurementUnit.MM:
            return convertToMm(nullFixedSize, fromUnits);
        case MeasurementUnit.CM:
            return convertToCm(nullFixedSize, fromUnits);
        case MeasurementUnit.M:
            return convertToM(nullFixedSize, fromUnits);
        case MeasurementUnit.PT:
        default:
            return convertToPt(nullFixedSize, fromUnits);
    }
}
export function convertPixelsToMm(pixelValue, ppi) {
    return in2mm(pixelValue / ppi);
}
//# sourceMappingURL=conversions.js.map